/**
 * Ideal Health NYC — Product Certification Badges
 * Uses official IP badge SVG assets. Renders protein badge dynamically.
 */

(function () {
  'use strict';

  const IP_CDN = 'https://ip-products.idealprotein.com/assets/images/product-details';
  const TAG_BADGE_MAP = {
    'gluten free':           `${IP_CDN}/Icon-GlutenFree.svg`,
    'kosher':                `${IP_CDN}/Icon-Kosher.svg`,
    'vegetarian':            `${IP_CDN}/Icon-Vegetarian.svg`,
    'sweetened with stevia': `${IP_CDN}/Icon-Stevia.svg`,
    'restricted':            `${IP_CDN}/Icon-Restriced.svg`,
  };

  function makeProteinBadgeSVG(grams) {
    const size = 72;
    const r = size / 2;
    const ir = r * 0.70;
    const topId  = 'ptop_' + Math.random().toString(36).slice(2, 8);
    const botId  = 'pbot_' + Math.random().toString(36).slice(2, 8);
    const textR  = r * 0.82;
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${size} ${size}" width="${size}" height="${size}" role="img" aria-label="${grams}g Protein">
  <defs>
    <path id="${topId}" d="M ${r - textR},${r} a ${textR},${textR} 0 0,1 ${textR * 2},0"/>
    <path id="${botId}" d="M ${r - textR},${r} a ${textR},${textR} 0 0,0 ${textR * 2},0"/>
  </defs>
  <circle cx="${r}" cy="${r}" r="${r - 1}" fill="#111111"/>
  <circle cx="${r}" cy="${r}" r="${ir}" fill="#D5EBC0"/>
  <text x="${r}" y="${r + ir * 0.32}" text-anchor="middle" font-family="'DM Sans','Poppins',sans-serif" font-weight="800" font-size="${ir * 0.72}" fill="#111111">${grams}g</text>
  <text font-family="'DM Sans',sans-serif" font-weight="700" font-size="7.8" fill="#111111" letter-spacing="0.8"><textPath href="#${topId}" startOffset="50%" text-anchor="middle">PROTEIN</textPath></text>
  <text font-family="'DM Sans',sans-serif" font-weight="700" font-size="7.8" fill="#111111" letter-spacing="0.8"><textPath href="#${botId}" startOffset="50%" text-anchor="middle">PROTEIN</textPath></text>
</svg>`;
  }

  function extractProteinGrams() {
    if (window.__ipProteinGrams && parseInt(window.__ipProteinGrams) > 0) {
      return parseInt(window.__ipProteinGrams);
    }
    const tables = document.querySelectorAll('.rte table, [class*="rte"] table');
    for (const table of tables) {
      for (const row of table.querySelectorAll('tr')) {
        const cells = row.querySelectorAll('td, th');
        if (cells.length >= 2) {
          const label = cells[0].textContent.trim().toLowerCase();
          if (label === 'protein' || label === 'protein (g)') {
            const m = cells[1].textContent.match(/(\d+)/);
            if (m && parseInt(m[1]) > 0) return parseInt(m[1]);
          }
        }
      }
    }
    return null;
  }

  function getProductTags() {
    if (window.__ipProductTags && Array.isArray(window.__ipProductTags)) {
      return window.__ipProductTags.map(t => t.toLowerCase());
    }
    return [];
  }

  function renderBadges() {
    // Only run on product pages
    if (!window.location.pathname.includes('/products/')) return;

    const tags = getProductTags();
    const protein = extractProteinGrams();
    const badgeItems = [];

    if (protein) {
      badgeItems.push(`<div class="ip-badge-item ip-badge-protein" title="${protein}g Protein">${makeProteinBadgeSVG(protein)}</div>`);
    }

    for (const [tag, src] of Object.entries(TAG_BADGE_MAP)) {
      if (tags.includes(tag)) {
        const label = tag.replace(/\b\w/g, c => c.toUpperCase());
        badgeItems.push(`<div class="ip-badge-item" title="${label}"><img src="${src}" alt="${label}" width="72" height="72" loading="lazy"></div>`);
      }
    }

    if (badgeItems.length === 0) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'ip-badges-row';
    wrapper.setAttribute('aria-label', 'Product certifications');
    wrapper.innerHTML = badgeItems.join('');

    // Insert directly after the product-price element
    const priceEl = document.querySelector('product-price');
    if (priceEl) {
      priceEl.insertAdjacentElement('afterend', wrapper);
    } else {
      // Fallback: insert at top of product-information
      const info = document.querySelector('.product-information');
      if (info) info.insertBefore(wrapper, info.firstChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderBadges);
  } else {
    setTimeout(renderBadges, 200);
  }

})();
